import React from 'react';
import './SectionVideo.css';

export default function SectionVideo({
    isEditing,
    videoUrl,
    setVideoUrl,
    videoVisible = true,
    setVideoVisible,
}) {
    
    // Tratamento estrito de parâmetros para embed de provedores
    const getEmbedUrl = (url) => {
        if (!url) return null;
        try {
            if (url.includes('youtube.com') || url.includes('youtu.be')) {
                const videoId = url.split('v=')[1]?.split('&')[0] || url.split('/').pop();
                return `https://www.youtube.com/embed/${videoId}`;
            }
            if (url.includes('instagram.com')) {
                return url.endsWith('/') ? `${url}embed` : `${url}/embed`;
            }
        } catch (error) {
            return null;
        }
        return null;
    };

    const embedUrl = getEmbedUrl(videoUrl);

    return (
        <section className="home-section section-video">
            {isEditing ? (
                <div className="input-group-home" style={{ alignItems: 'center', marginBottom: '1.5rem' }}>
                    <label>Título da Seção</label>
                    <input type="text" className="input-admin-home text-center" defaultValue="Vídeo Institucional" disabled />
                </div>
            ) : (
                <h4 className="section-title-blue text-center">Vídeo Institucional</h4>
            )}

            <div className="video-admin-wrapper">
                {isEditing && (
                    <label className="video-visibility-toggle">
                        <input
                            type="checkbox"
                            checked={videoVisible}
                            onChange={(event) => setVideoVisible?.(event.target.checked)}
                        />
                        Mostrar vídeo institucional na Home
                    </label>
                )}

                <div className="video-preview-container">
                    {!videoVisible ? (
                        <div className="video-placeholder">
                            <svg viewBox="0 0 24 24" width="48" height="48" fill="#cbd5e1">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
                            </svg>
                            <p>Vídeo oculto na Home</p>
                        </div>
                    ) : embedUrl ? (
                        <iframe 
                            src={embedUrl} 
                            title="Vídeo Institucional" 
                            frameBorder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen
                            className="video-iframe"
                        ></iframe>
                    ) : (
                        <div className="video-placeholder">
                            <svg viewBox="0 0 24 24" width="48" height="48" fill="#cbd5e1">
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"/>
                            </svg>
                            <p>Nenhum vídeo configurado</p>
                        </div>
                    )}

                    {isEditing && (
                        <div className="video-edit-overlay">
                            <div className="input-group-video">
                                <label>Link do YouTube ou Instagram</label>
                                <input 
                                    type="text" 
                                    className="input-admin-home" 
                                    value={videoUrl}
                                    onChange={(e) => setVideoUrl(e.target.value)}
                                    placeholder="Ex: https://www.youtube.com/watch?v=..."
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
